<template>
  <Layout>
    <div class="flex flex-wrap is-main-layout">
      <div class="flex-none">
        <Sidebar
          :heightItem="750"
          :menuList="layoutData.menu"
          :onClickSubMenu="
            (index, isSub = true) => {
              onClickSubMenu(index, isSub);
            }
          "
          :onClickLogo="
            () => {
              console.log('onClickLogo');
            }
          "
        />
      </div>
      <div class="flex-1">
        <slot />
      </div>
    </div>

    <Notifications :group="'tailwind'">
      <template #body="props">
        <Toast
          class="mt-2 mr-6"
          :isError="props.item.data.isError"
          :isWarning="props.item.data.isWarning"
          :isNotice="props.item.data.isNotice"
          :isDisabled="props.item.data.isDisabled"
          :label="props.item.text"
          :onClick="props.close"
        />
      </template>
    </Notifications>

    <!-- Loading Overlay -->
    <LoadingOverlay v-if="isShowLoading" :isFlow="true" :isPulse="false" :isCircleFade="false" />
  </Layout>
</template>

<script setup>
const isShowLoading = useIsShowLoading();
console.log("🚀 ~ isShowLoading:", isShowLoading.value);
import { useNuxtApp } from '#app';

useSessionExpiry();

const { $constants } = useNuxtApp();
const layoutData = reactive({
  menu: [
    {
      name: "Home",
      icon: "/images/icons/ic-breadcrumb.svg",
      path: $constants.ROUTE.HOME.LINK,
      subMenu: null,
      isShowSubMenu: true,
    },
  ],
});

const checkPath = () => {
  layoutData.menu = layoutData.menu.map((e) => {
    if (e.subMenu) {
      e.subMenu.forEach((sub) => {
        if (sub.path === route.fullPath) {
          e.isShowSubMenu = true;
        }
      });
    }
    return e;
  });
};

const onClickSubMenu = (index, isSub) => {
  if (isSub) {
    layoutData.menu[index].isShowSubMenu = !layoutData.menu[index].isShowSubMenu;
  } else {
    layoutData.menu.forEach((item) => {
      if (item.subMenu) {
        item.isShowSubMenu = false;
      }
    });
  }
};

checkPath();
</script>

<style lang="scss">
.is-main-layout {
  display: flex;
}
</style>
